import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Resources from '../components/Resources';
import Blog from '../components/Blog';
import BlogArticle from '../components/BlogArticle';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const MainWebsite = ({ siteData, error }) => {
    const [activeSection, setActiveSection] = useState('home');
    const [selectedArticle, setSelectedArticle] = useState(null);

    const handleArticleClick = (article) => {
        setSelectedArticle(article);
    };

    const handleBackToBlog = () => {
        setSelectedArticle(null);
    };

    const handleNavigateWithScroll = (section) => {
        setSelectedArticle(null); // Clear selected article when changing sections
        setActiveSection(section);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const renderSection = () => {
        // If an article is selected, show the article view
        if (selectedArticle) {
            return <BlogArticle post={selectedArticle} onBack={handleBackToBlog} />;
        }

        switch (activeSection) {
            case 'home':
                return (
                    <>
                        <Hero data={siteData.hero} onNavigate={handleNavigateWithScroll} />
                        <About data={siteData.about} />
                    </>
                );
            case 'about':
                return <About data={siteData.about} />;
            case 'services':
                return <Services data={siteData.services} onNavigate={handleNavigateWithScroll} />;
            case 'resources':
                return <Resources data={siteData.resources} />;
            case 'blog':
                return <Blog data={siteData.blog} onArticleClick={handleArticleClick} />;
            case 'contact':
                return <Contact data={siteData.contact} onNavigate={handleNavigateWithScroll} />;
            default:
                return (
                    <>
                        <Hero data={siteData.hero} onNavigate={handleNavigateWithScroll} />
                        <About data={siteData.about} />
                        <Services data={siteData.services} onNavigate={handleNavigateWithScroll} />
                        <Testimonials data={siteData.testimonials} onNavigate={handleNavigateWithScroll} />
                    </>
                );
        }
    };

    return (
        <div className="min-h-screen bg-stone-50">
            <Navbar
                activeSection={activeSection}
                setActiveSection={handleNavigateWithScroll} // Use the new method here too
                data={siteData.navbar}
            />

            {/* Error notification */}
            {error && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 text-center">
                    {error}
                </div>
            )}

            <main>
                {renderSection()}
            </main>

            <Footer onNavigate={handleNavigateWithScroll} siteData={siteData} />
        </div>
    );
};

export default MainWebsite;